$(document).ready(function() {
    if ($("body.page-instantOrder").length) {
        var zipTabContent = $('.js-session-address-popup').data('content');
        // when the zipcode header element is present
        // and the zipcode input is empty
        // the direct order page will be blocked
        if (zipTabContent && zipTabContent.includes('value=""')) {
            $('.instant-order-cursor-block-overlay').addClass('active');
            setTimeout(function() {
                $(".js-session-address-popup").trigger('mouseenter');
                $(".js-session-address-popup").off("mouseleave");
                $(".js-session-address-popup").off("mouseout");
            }, 500)
        }
    }
});
